/**
 * The screen sharing texts, in their own i18n namespace ('screenShare') so
 * they live next to the feature. Plain words, no technical terms, no
 * provider names.
 */
import i18n from '@/i18n'

const fr = {
  widget: {
    title: 'Partager mon écran',
    subtitle: 'Le support vous montre où cliquer',
  },
  confirm: {
    title: 'Partager votre écran avec le support ?',
    message: 'Le support verra votre page Callizy et vous montrera où cliquer, sans pouvoir agir à votre place. Les mots de passe, cartes, codes et clés restent masqués.',
    share: 'Partager',
    cancel: 'Annuler',
  },
  code: {
    title: 'Votre code',
    help: 'Le support vous rejoint ici. Au téléphone, donnez-lui ce code. Valable {{minutes}} min.',
    waiting: 'En attente du support…',
    cancel: 'Annuler le partage',
  },
  request: {
    title: 'Le support veut voir votre écran',
    message: '{{name}} vous montrera où cliquer, sans pouvoir agir à votre place. Les mots de passe, cartes, codes et clés restent masqués.',
    accept: 'Accepter',
    refuse: 'Refuser',
    expires: 'Expire dans {{seconds}} s',
  },
  banner: {
    live: 'Le support voit votre écran',
    away: 'Le support se reconnecte…',
    waiting: 'Le support arrive…',
    stop: 'Arrêter',
  },
  end: {
    client: 'Partage terminé.',
    support: 'Le support a terminé le partage.',
    duree: '60 minutes écoulées : partage terminé.',
    deconnexion: "Le partage s'est arrêté.",
    erreur: "Le partage s'est arrêté.",
  },
  errors: {
    expire: 'Cette demande a expiré.',
    deja_repondu: 'Cette demande a déjà reçu une réponse.',
    deja_en_cours: 'Un partage est déjà en cours.',
    default: "Le partage n'a pas pu démarrer. Réessayez.",
  },
}

const en: typeof fr = {
  widget: {
    title: 'Share my screen',
    subtitle: 'Support shows you where to click',
  },
  confirm: {
    title: 'Share your screen with support?',
    message: 'Support will see your Callizy page and show you where to click, without being able to act for you. Passwords, cards, codes and keys stay hidden.',
    share: 'Share',
    cancel: 'Cancel',
  },
  code: {
    title: 'Your code',
    help: 'Support joins you here. On the phone, give them this code. Valid for {{minutes}} min.',
    waiting: 'Waiting for support…',
    cancel: 'Cancel sharing',
  },
  request: {
    title: 'Support would like to see your screen',
    message: '{{name}} will show you where to click, without being able to act for you. Passwords, cards, codes and keys stay hidden.',
    accept: 'Accept',
    refuse: 'Decline',
    expires: 'Expires in {{seconds}} s',
  },
  banner: {
    live: 'Support can see your screen',
    away: 'Support is reconnecting…',
    waiting: 'Support is joining…',
    stop: 'Stop',
  },
  end: {
    client: 'Sharing ended.',
    support: 'Support ended the sharing.',
    duree: '60 minutes passed: sharing ended.',
    deconnexion: 'Sharing stopped.',
    erreur: 'Sharing stopped.',
  },
  errors: {
    expire: 'This request has expired.',
    deja_repondu: 'This request was already answered.',
    deja_en_cours: 'A sharing session is already in progress.',
    default: 'Sharing could not start. Please try again.',
  },
}

i18n.addResourceBundle('fr', 'screenShare', fr, true, false)
i18n.addResourceBundle('en', 'screenShare', en, true, false)

export const SCREEN_SHARE_NS = 'screenShare'
